import * as React from 'react';

import ContentSharing32 from './ContentSharing32';

export const contentSharing32 = () => <ContentSharing32 />;

export default {
    title: 'Icon/Content/ContentSharing32',
    component: ContentSharing32,
    parameters: {
        notes: "`import ContentSharing32 from 'box-ui-elements/es/icon/content/ContentSharing32';`",
    },
};
